import React, { useEffect, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import DatePicker, { registerLocale } from "react-datepicker";
import iconcontentcalendar from "../../Images/Icons/iconcontentcalendar.png";
import * as dateHelper from "../../Helpers/DateHelper";
import Tooltip from "../Common/Tooltip";
import certificateImg from "../../Images/certificateImg.png";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { lettersAndNumbers } from "../../Config/Regex";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import { Modal } from "react-bootstrap";
registerLocale("hr", hr);
registerLocale("en", en);

const CertificateData = (props) => {
  const back = () => {
    props.prevStep();
  };

  const {
    values,
    uploadCertificateData,
    setUploadCertificateData,
    handleInputChange,
    showPreview,
    setShowPreview,
  } = props;
  const { selectedLanguageId } = useContext(GlobalContext);
  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const { t: translator } = useTranslation();
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (values.validFrom !== "" && values.validTo !== "") {
      setValue("validFrom", new Date(values.validFrom));
      setValue("validTo", new Date(values.validTo));
    }
  }, []);

  const goTo = (data) => {
    if (
      document.getElementsByName("fileContent1")[0] !== undefined &&
      !document.getElementsByName("fileContent1")[0].value
    ) {
      setShowWarning(true);
    } else {
      setUploadCertificateData({
        name: data.name,
        fileContent: uploadCertificateData.fileContent
          ? uploadCertificateData.fileContent
          : data.fileContent[0],
        validFrom: data.validFrom,
        validTo: data.validTo,
        certPassword: data.certPassword,
      });
      props.nextStep();
    }
  };

  const checkIsP12 = (uploadedFile) => {
    if (!uploadedFile) return true;
    if (uploadedFile.type === "application/x-pkcs12") {
      document.getElementsByName("fileContent")[0].files =
        document.getElementsByName("fileContent1")[0].files;
      setShowPreview(true);
      return true;
    }
    return false;
  };

  const handleRemoveCert = () => {
    setValue("fileContent", null);
    setShowPreview(false);
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-CertificateData-CertificateData")}
            </legend>
            <div className="form-group">
              <label>
                {translator("Onboarding-CertificateData-CertificateName")}
              </label>{" "}
              <Tooltip text={translator("CertificateDataName-Msg")} />
              <input
                type="text"
                className="form-control"
                name="name"
                ref={register({
                  maxLength: 50,
                  pattern: lettersAndNumbers,
                })}
                defaultValue={uploadCertificateData.name}
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength50")}
                </p>
              )}
              {errors.name && errors.name.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersAndNumbers")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Password")}</label>{" "}
              <Tooltip text={translator("Certificate-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                name="certPassword"
                ref={register({
                  maxLength: 50,
                })}
                onChange={handleInputChange}
              />
            </div>
            {!showPreview && (
              <div className="form-group">
                <label>
                  {translator("Onboarding-CertificateData-Certificate")}
                </label>{" "}
                <input
                  type="file"
                  className="form-control-file"
                  name="fileContent1"
                  ref={register({
                    validate: () =>
                      checkIsP12(
                        document.getElementsByName("fileContent1")[0].files[0]
                      ),
                  })}
                />
                {errors.fileContent1 &&
                  errors.fileContent1.type === "validate" && (
                    <p className="text-danger">
                      {translator("CertificateData-FileValidation")}
                    </p>
                  )}
              </div>
            )}
            <div className="form-row">
              <div className="form-group col-md-6">
                {showPreview && (
                  <img
                    src={certificateImg}
                    alt="certificiate"
                    className="logoPreview"
                  />
                )}
              </div>
              <div className="form-group col-md-4">
                {showPreview && (
                  <>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={handleRemoveCert}
                    >
                      <i className="fas fa-trash-alt text-secondary"></i>
                    </button>
                    &nbsp;<span>{translator("Remove-Certificate")}</span>
                  </>
                )}
              </div>
            </div>
            <input type="file" hidden name="fileContent" ref={register} />
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-CertificateData-Subscription")}
            </legend>
            <div className="form-group">
              <label htmlFor="certificateValidFrom">
                {translator("Onboarding-CertificateData-CertificateValidFrom")}
              </label>{" "}
              <Tooltip text={translator("CertificateDataFromDate-Msg")} />
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <img src={iconcontentcalendar} alt="calendar" />
                  </span>
                </div>
                <Controller
                  as={DatePicker}
                  control={control}
                  autoComplete="off"
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                  name="validFrom"
                  showYearDropdown={true}
                  valueName="selected"
                  locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                  value={dateHelper.formatUtcToDate(values.validFrom)}
                  onChange={function ([selected]) {
                    handleInputChange(
                      "validFrom",
                      dateHelper.datePickerDateToUtc(selected)
                    );
                    return selected;
                  }}
                  maxDate={
                    values.validTo != ""
                      ? new Date(values.validTo)
                      : new Date(8640000000000000)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="certificateValidTo">
                {translator("Onboarding-CertificateData-CertificateValidTo")}
              </label>{" "}
              <Tooltip text={translator("CertificateDataToDate-Msg")} />
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <img src={iconcontentcalendar} alt="calendar" />
                  </span>
                </div>
                <Controller
                  as={DatePicker}
                  control={control}
                  autoComplete="off"
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                  name="validTo"
                  showYearDropdown={true}
                  valueName="selected"
                  locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                  value={dateHelper.formatUtcToDate(values.validTo)}
                  onChange={function ([selected]) {
                    handleInputChange(
                      "validTo",
                      dateHelper.datePickerDateToUtc(selected)
                    );
                    return selected;
                  }}
                  minDate={
                    values.validFrom != ""
                      ? new Date(values.validFrom)
                      : new Date(8640000000000000)
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <button className="btn btn-outline-secondary" onClick={back}>
            {translator("Onboarding-Btn-Back")}
          </button>
        </div>
        <div className="col-6 text-right">
          <button className="btn btn-primary" onClick={handleSubmit(goTo)}>
            {translator("Onboarding-Btn-Next")}
          </button>
        </div>
      </div>
      <Modal show={showWarning} centered>
        <Modal.Header>
          <Modal.Title>{translator("CertificateWarning-Title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{translator("CertificateWarning-Text")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-dismiss="modal"
            onClick={() => setShowWarning(false)}
          >
            {translator("Users-DeleteModal-Cancel")}
          </button>
          <button
            onClick={() => props.nextStep()}
            type="button"
            className="btn btn-primary"
          >
            {translator("Onboarding-Btn-Next")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CertificateData;
